import ApiService from "./ApiService";
import { getData } from "../ClientConsumer";
import { Content } from "../../Presentation/Pages/GroupDetailsPage/Components/Modals/ContentSearchModal/SearchContent/ContentResultList/ContentListItem/ContentListItem.types";

function fetchSearchResults(
    value: string,
    groupId: number,
    excludePostId?: number,
    searchVariant?: string,
    limit?: number,
): Promise<Content[]> {
    return getData(ApiService.COMMUNITY_SEARCH_CONTENT, {
        params: { query: value, groupId, excludePostId, searchVariant, limit },
    }).then((res) => {
        return res.data;
    });
}

export function searchByContent(
    value: string,
    groupId: number,
    excludePostId?: number,
    searchVariant?: string,
    limit?: number,
) {
    return fetchSearchResults(
        value,
        groupId,
        excludePostId,
        searchVariant,
        limit,
    );
}
